"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkEstimationProvider = void 0;
var vpt_abr_common_1 = require("@sky-uk-ott/vpt-abr-common");
var bandwidth_estimator_1 = require("./bandwidth-estimator");
var latency_estimator_1 = require("./latency-estimator");
var round_trip_time_estimator_1 = require("./round-trip-time-estimator");
var NetworkEstimationProvider = /** @class */ (function () {
    function NetworkEstimationProvider(config) {
        if (config === void 0) { config = {}; }
        this.logger = new vpt_abr_common_1.Logger('Network Estimation');
        this.unregisterLogHandlers = (0, vpt_abr_common_1.applyLoggingConfig)(this.logger, config.logging);
    }
    NetworkEstimationProvider.prototype.createBandwidthEstimator = function (config, getStabilisedBufferAheadSeconds) {
        if (config === void 0) { config = {}; }
        this.logger.info('Creating bandwidth estimator with config', config);
        return new bandwidth_estimator_1.BandwidthEstimator(this.logger, config, getStabilisedBufferAheadSeconds);
    };
    NetworkEstimationProvider.prototype.createLatencyEstimator = function () {
        this.logger.info('Creating latency estimator');
        return new latency_estimator_1.LatencyEstimator(this.logger);
    };
    NetworkEstimationProvider.prototype.createRoundTripTimeEstimator = function () {
        this.logger.info('Creating round-trip time estimator');
        return new round_trip_time_estimator_1.RoundTripTimeEstimator(this.logger);
    };
    NetworkEstimationProvider.prototype.destroy = function () {
        this.unregisterLogHandlers();
    };
    return NetworkEstimationProvider;
}());
exports.NetworkEstimationProvider = NetworkEstimationProvider;
